import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitButton", "syncInProgress"]

  connect() {
    this.$form = $(this.element).find("form").first();
    if (!this.$form.length) this.$form = $(this.element).closest("form");

    this.initialState = this.serializeForm();

    this.$form.on("change", () => this.checkDirty());
  }

  checkDirty() {
    // Skip dirty check if block-settings is in edit mode
    var blockSettings = this.element.querySelector("[data-controller*='google-calendar-block-settings']");
    if (blockSettings) {
      var controller = this.application.getControllerForElementAndIdentifier(blockSettings, "google-calendar-block-settings");
      if (controller && controller.isEditing()) return;
    }

    var dirty = this.initialState !== this.serializeForm();

    // Don't show submit button if sync is already in progress
    if (this.hasSyncInProgressTarget && !$(this.syncInProgressTarget).hasClass("d-none")) return;

    if (dirty) {
      $(this.submitButtonTarget).removeClass("d-none");
    } else {
      $(this.submitButtonTarget).addClass("d-none");
    }
  }

  serializeForm() {
    if (!this.$form.length) return "";

    var entries = [];
    this.$form.find("input, select, textarea").each(function () {
      var $el = $(this);
      if (!$el.attr("name")) return;

      if ($el.is(":checkbox") || $el.is(":radio")) {
        entries.push($el.attr("name") + "=" + $el.val() + ":" + $el.is(":checked"));
      } else {
        entries.push($el.attr("name") + "=" + $el.val());
      }
    });

    return entries.sort().join("&");
  }

  submitForm(event) {
    event.preventDefault();

    var $btn = $(this.submitButtonTarget);
    var originalHtml = $btn.html();
    $btn.prop("disabled", true).html($btn.data("disable-with") || originalHtml);

    $.ajax({
      url: this.$form.attr("action"),
      type: this.$form.attr("method"),
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      data: this.$form.serialize(),
      dataType: "json",
      success: (response) => {
        var message = response.message || "Saved!";
        window.notyf.success(message);
        $(this.submitButtonTarget).addClass("d-none").prop("disabled", false).html(originalHtml);
        this.initialState = this.serializeForm();
        if (this.hasSyncInProgressTarget) {
          $(this.syncInProgressTarget).removeClass("d-none");
          this.$form.find("input, select, button").not(this.submitButtonTarget).prop("disabled", true);

          var blockSettings = this.element.querySelector("[data-controller*='google-calendar-block-settings']");
          if (blockSettings) {
            var controller = this.application.getControllerForElementAndIdentifier(blockSettings, "google-calendar-block-settings");
            if (controller && controller.hasEditButtonTarget) {
              $(controller.editButtonTarget).addClass("d-none");
            }
          }
        }
      },
      error: (response) => {
        var message =
          (response.responseJSON && response.responseJSON.error) ||
          "Sorry, something went wrong. No data was changed.";
        window.notyf.error(message);
        $btn.prop("disabled", false).html(originalHtml);
      },
    });
  }

  resetInitialState() {
    this.initialState = this.serializeForm();
    $(this.submitButtonTarget).addClass("d-none");
  }
}
